import React, { useState } from 'react';
import { 
    Table, Button, Card, Space, Form, Input, Select, 
    Radio, Upload, message, Typography, Tag, Tooltip, Drawer
} from 'antd';
import { 
    UploadOutlined, HistoryOutlined, ArrowLeftOutlined,
    InfoCircleOutlined, DownloadOutlined
} from '@ant-design/icons';
const { Title, Text, Link } = Typography;

const { Option } = Select;

const CardManage = () => {
    const [view, setView] = useState('list'); // 'list' | 'records'
    const [importModalVisible, setImportModalVisible] = useState(false);
    const [usageType, setUsageType] = useState('self'); // 'self' | 'allocation'
    const [form] = Form.useForm();
    const [searchForm] = Form.useForm();

    // 模拟主列表数据
    const [cardData] = useState([
        { id: 1, iccid: 'TEST-LIC-0047', status: 'pending', activeTime: '-', remainingData: '0KB', vendor: '麦联宝', source: '鹤梦平台', importTime: '2026-01-08 17:18:10' },
        { id: 2, iccid: 'TEST-LIC-0046', status: 'pending', activeTime: '-', remainingData: '0KB', vendor: '万物互联', source: '鹤梦平台', importTime: '2026-01-08 17:18:10' },
        { id: 3, iccid: 'TEST-LIC-0045', status: 'pending', activeTime: '-', remainingData: '0KB', vendor: '麦联宝', source: '鹤梦平台', importTime: '2026-01-08 17:18:10' },
        { id: 4, iccid: 'TEST-LIC-0044', status: 'pending', activeTime: '-', remainingData: '0KB', vendor: '桔子智联', source: '鹤梦平台', importTime: '2026-01-08 17:18:10' },
    ]);

    // 模拟调拨记录数据
    const [recordData] = useState([
        { id: 5, targetEnt: '汇云科技', targetEntId: 'ENT-HUIYUN-01', vendorName: '麦联宝', vendorId: 'VEND-MLB-001', count: 1, remark: 'dddd', time: '2026-01-29 17:57:02' },
        { id: 4, targetEnt: '产研测试验证企业', targetEntId: 'ENT-TEST-099', vendorName: '万物互联', vendorId: 'VEND-WWH-002', count: 1, remark: 'dsfffds', time: '2026-01-28 14:20:08' },
        { id: 3, targetEnt: '产研测试验证企业', targetEntId: 'ENT-TEST-099', vendorName: '麦联宝', vendorId: 'VEND-MLB-001', count: 1, remark: 'ddd', time: '2026-01-28 14:09:56' },
        { id: 2, targetEnt: '小鹤看家', targetEntId: 'ENT-XIAOHE-88', vendorName: '桔子智联', vendorId: 'VEND-JZZL-05', count: 1, remark: '小鹤看家调拨测试', time: '2026-01-19 11:03:32' },
        { id: 1, targetEnt: '产研测试验证企业', targetEntId: 'ENT-TEST-099', vendorName: '麦联宝', vendorId: 'VEND-MLB-001', count: 102, remark: 'bz', time: '2026-01-01 01:55:05' },
    ]);

    const cardColumns = [
        { title: '序号', dataIndex: 'id', key: 'id', width: 70 },
        { title: 'ICCID', dataIndex: 'iccid', key: 'iccid' },
        { title: '卡商', dataIndex: 'vendor', key: 'vendor' },
        { 
            title: '状态', 
            dataIndex: 'status', 
            key: 'status',
            render: (s) => s === 'pending' ? <Text type="secondary">待激活</Text> : <Tag color="success">已激活</Tag>
        },
        { title: '激活时间', dataIndex: 'activeTime', key: 'activeTime' },
        { title: '剩余流量', dataIndex: 'remainingData', key: 'remainingData' },
        { title: '来源企业', dataIndex: 'source', key: 'source' },
        { title: '导入时间', dataIndex: 'importTime', key: 'importTime' },
    ];

    const recordColumns = [
        { title: '序号', dataIndex: 'id', key: 'id', width: 70 },
        { 
            title: '调入企业', 
            key: 'targetEntInfo',
            render: (_, r) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{r.targetEnt}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>ID: {r.targetEntId}</Text>
                </div>
            )
        },
        {
            title: '所属卡商',
            key: 'vendorInfo',
            render: (_, r) => (
                <div>
                    <div>{r.vendorName}</div>
                    <Text type="secondary" style={{ fontSize: 11 }}>{r.vendorId}</Text>
                </div>
            )
        },
        { title: '批次数量', dataIndex: 'count', key: 'count' },
        { title: '备注信息', dataIndex: 'remark', key: 'remark', ellipsis: true },
        { title: '调拨时间', dataIndex: 'time', key: 'time' },
        { 
            title: '操作', 
            key: 'action',
            render: () => <Button type="link">导出详情</Button>
        },
    ];

    const handleImport = () => {
        form.validateFields().then(() => {
            message.success('导入成功');
            setImportModalVisible(false);
            form.resetFields();
        });
    };

    const renderListView = () => (
        <>
            <div style={{ background: '#fff', padding: '16px 24px', marginBottom: 16, borderRadius: 8 }}>
                <Form layout="inline" form={searchForm}>
                    <Form.Item label="ICCID" name="iccid">
                        <Input placeholder="请输入" style={{ width: 200 }} />
                    </Form.Item>
                    <Form.Item label="卡商" name="vendor">
                        <Select placeholder="请选择" style={{ width: 180 }} allowClear showSearch optionFilterProp="label"
                            options={[
                                { label: '麦联宝', value: '麦联宝' },
                                { label: '万物互联', value: '万物互联' },
                                { label: '桔子智联', value: '桔子智联' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item label="状态" name="status">
                        <Select placeholder="请选择" style={{ width: 160 }} allowClear>
                            <Option value="pending">待激活</Option>
                            <Option value="active">已激活</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button type="primary" onClick={() => message.info('查询中')}>查询</Button>
                            <Button onClick={() => searchForm.resetFields()}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>

            <Card bordered={false} bodyStyle={{ padding: '0 24px 24px' }}>
                <div style={{ padding: '16px 0', display: 'flex', gap: 12 }}>
                    <Button type="primary" icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>导入4G卡</Button>
                    <Button icon={<HistoryOutlined />} onClick={() => setView('records')}>查看调拨记录</Button>
                </div>
                <Table 
                    rowKey="id"
                    columns={cardColumns} 
                    dataSource={cardData} 
                    pagination={{ 
                        total: 19, 
                        showSizeChanger: true, 
                        showTotal: (total) => `共${total}条记录` 
                    }} 
                />
            </Card>
        </>
    );

    const renderRecordsView = () => (
        <Card bordered={false}>
            <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 16 }}>
                <Button icon={<ArrowLeftOutlined />} onClick={() => setView('list')}>返回</Button>
                <Title level={4} style={{ margin: 0 }}>4G卡调拨详情</Title>
            </div>
            
            <Form layout="inline" style={{ marginBottom: 24 }}>
                <Form.Item label="ICCID">
                    <Input placeholder="请输入" style={{ width: 200 }} />
                </Form.Item>
                <Form.Item>
                    <Space>
                        <Button type="primary">查询</Button>
                        <Button>重置</Button>
                    </Space>
                </Form.Item>
            </Form>

            <Table 
                rowKey="id"
                columns={recordColumns} 
                dataSource={recordData} 
                pagination={{ total: 5, showTotal: (total) => `共${total}条记录` }} 
            />
        </Card>
    );

    return (
        <div style={{ padding: '24px' }}>
            {view === 'list' ? renderListView() : renderRecordsView()}

            <Drawer
                title="导入4G卡"
                width={560}
                onClose={() => setImportModalVisible(false)}
                open={importModalVisible}
                destroyOnClose
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Button onClick={() => setImportModalVisible(false)} style={{ marginRight: 8 }}>取消</Button>
                        <Button type="primary" onClick={handleImport}>确定</Button>
                    </div>
                }
            >
                <Form form={form} layout="horizontal" labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} style={{ marginTop: 12 }}>
                    <Form.Item label="4G卡商" name="vendor" rules={[{ required: true, message: '请选择卡商' }]}>
                        <Select placeholder="请选择">
                            <Option value="mlb">麦联宝</Option>
                            <Option value="wwhl">万物互联电信</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="运营商" name="operator">
                        <Select placeholder="请选择">
                            <Option value="chinamobile">中国移动</Option>
                            <Option value="chinaunicom">中国联通</Option>
                            <Option value="chinatelecom">中国电信</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="用途" name="usage" initialValue="self" rules={[{ required: true }]}>
                        <Radio.Group onChange={(e) => setUsageType(e.target.value)}>
                            <Radio value="self">自用流量卡</Radio>
                            <Radio value="allocation">
                                调拨流量卡 <Tooltip title="调拨给其他企业使用的卡"><InfoCircleOutlined /></Tooltip>
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="上传流量卡" required>
                        <Space align="center">
                            <Upload beforeUpload={() => false} maxCount={1}>
                                <Button icon={<UploadOutlined />} type="primary">上传文件</Button>
                            </Upload>
                            <Link icon={<DownloadOutlined />}>下载模板</Link>
                        </Space>
                        <div style={{ marginTop: 8, color: '#999', fontSize: 12 }}>
                            请下载模板后添加导入，单次最大导入5000张
                        </div>
                    </Form.Item>

                    {usageType === 'allocation' && (
                        <>
                            <Form.Item label="调入企业" name="targetEnt" rules={[{ required: true, message: '请输入调入企业' }]}>
                                <Input.Search placeholder="请输入对方企业ID" enterButton="搜索" onSearch={(v) => message.success('搜索企业: ' + v)} />
                            </Form.Item>
                            <Form.Item label="备注信息" name="remark">
                                <Input.TextArea placeholder="请输入备注" rows={4} maxLength={500} showCount />
                            </Form.Item>
                        </>
                    )}
                </Form>
            </Drawer>
        </div>
    );
};

export default CardManage;
